import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Bentley = ({featuredProjectsList}) => {
  const project = getProject('bentley');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            video: '99757854',
            posterVideo: '215749421'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            A Bentley isn’t your average car, so neither should be the process
            of selecting the Bentley of your dreams.
          </p>
          <p>
            With over 1.3 billion possible unique combinations, how do you find
            the one Bentley that’s unmistakably you?
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20170503182959/photo1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="the-experience">The experience</h2>
          <p>
            An experience using first-of-its-kind technology to explore the true
            nature of their drivers. So that we may reveal the perfect Bentley
            for each of them. Premiered at VIP events across the country
            including New York, Pebble Beach and Los Angeles. Bentley Studio was
            a journey into the subconscious of prospective customers that used
            color theory, emotional quotient and psychology.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503183001/photo2.jpg',
            caption:
              'Guests chose between a series of visuals from art and fashion, to nature and architecture.'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170508043019/montage.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503183005/photo4.jpg',
            caption:
              'Each guest’s choices were synthesized into insights, which were mapped on the Bentley personality matrix. Every element of their story inspired a detail of their car.'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503183007/photo5.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503183009/photo6.jpg',
            caption:
              'A commissioner summarized their choices before a Bentley designer sketched finishing touches for each guest’s creation.'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            For each guest, a unique and personalized Bentley experience.
            Bespoke luxury, perfectly suited, with personality in mind.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            Momentum
            <br />
            Red Paper Heart
          </p>
        </AnimateIn>

        <LinkList
          component={{
            title: 'Press',
            useLinksDirectly: true,
            links: [
              {
                title: 'What It’s Like To Buy A $200K Bentley In 2014',
                url:
                  'http://www.fastcodesign.com/3030672/what-its-like-to-buy-a-200k-bentley-in-2014',
                source: 'Fast Company'
              },
              {
                title:
                  'Bentley Studio Gives Customers A Chance To Design Their Dream Car',
                url: 'http://www.psfk.com/2014/05/bentley-design-studio.html',
                source: 'PSFK'
              },
              {
                title: 'Build Your Own Bentley',
                url:
                  'http://www.ozy.com/good-sht/build-your-own-bentley/31654.article',
                source: 'Ozy'
              },
              {
                title:
                  'Frieze Art Fair Brings Auto-Themed Displays to New York',
                url:
                  'http://www.nytimes.com/2014/05/22/automobiles/frieze-art-fair-brings-auto-themed-displays-to-new-york.html',
                source: 'The New York Times'
              }
            ]
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Creative Strategy',
                  'Experience Mapping',
                  'Prototyping & Validation',
                  'Technical Strategy'
                ]
              },

              {
                title: 'Design',
                items: [
                  '3D Animation',
                  'Art Direction',
                  'Motion Design',
                  'UI/UX Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping',
                  'Systems Architecture'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Analytics & Insights',
                  'Integration Support',
                  'Launch',
                  'Monitoring',
                  'Quality Assurance',
                  'Staff Training & Support'
                ]
              },

              {
                title: 'Content',
                items: ['Post Production']
              },

              {
                title: 'Experiential',
                items: [
                  'Custom Hardware',
                  'Hardware Specification',
                  'Immersive Environment',
                  'Installation Prototyping',
                  'Interactive Environment',
                  'Video Installation',
                  'Video Mapping + Projection'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Bentley;
